export default __webpack_public_path__ + "static/media/4c.a1836a6c.png";